import React, { FC } from 'react';
import { TFunction, useTranslation } from 'react-i18next';
import styled from 'styled-components';
import {
  DeleteConfirmation,
  DeletePlacementLabel,
} from '../../../common/model/type/video-placement.types';

interface OvDeleteVideoConsequencesProps {
  confirmation: DeleteConfirmation;
}

const getPlacementName = (
  placement: DeletePlacementLabel,
  t: TFunction
): string => {
  switch (placement.kind) {
    case 'described':
      return placement.description;
    case 'unavailable':
      return t('videos.delete.unavailablePlacement', { key: placement.key });
    default: {
      const unreachable: never = placement;

      return unreachable;
    }
  }
};

const OvDeleteVideoConsequences: FC<OvDeleteVideoConsequencesProps> = ({
  confirmation: {
    action,
    placement,
    isPendingReplacement,
    hasPendingReplacement,
    upload,
  },
}) => {
  const { t } = useTranslation();

  return (
    <Body>
      <p>
        {placement &&
          `${t('videos.delete.placed', {
            placement: getPlacementName(placement, t),
          })} `}
        {t(`videos.delete.${action}${placement ? 'Placed' : ''}Body`)}
      </p>
      {isPendingReplacement && <p>{t('videos.delete.pendingReplacement')}</p>}
      {hasPendingReplacement && (
        <p>{t('videos.delete.hasPendingReplacement')}</p>
      )}
      {upload === 'local' && <p>{t('videos.delete.stopsLocalUpload')}</p>}
      {upload === 'notFinished' && <p>{t('videos.notices.noUploadHere')}</p>}
    </Body>
  );
};

export default OvDeleteVideoConsequences;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  p {
    margin: 0;
  }
`;
